import React, { CSSProperties } from 'react';

import { useTheme } from 'themes/themeProvider';
import { imageMap } from 'utils/imageMap';

import styles from './Logo.module.scss';

export const Logo = () => {
  const { theme } = useTheme();

  const logoUrl = theme.logoUrl ?? imageMap.logos[theme.logo.imageId];

  const style: CSSProperties = {
    '--logo-url': `url(${logoUrl})`,
    '--logo-height': theme.logo.height,
    '--logo-width': theme.logo.width,
    backgroundPosition: 'center',
  } as React.CSSProperties;

  return (
    <div className={styles.logo} style={style}>
      <div className='logo' />
      <div className={styles.hideImage} />
    </div>
  );
};
